import { Grid } from '@material-ui/core'
import Formulaire from 'Components/Formulaire'
import Modal from 'Components/Modal'
import ApiRequest from 'EurestoApi/ApiRequest'
import User from 'EurestoClass/User'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import project from 'EurestoConfig/project.config'
import Constants from 'EurestoFonction/Constants'
import Utils from 'EurestoFonction/Utils'
import React, { useState } from 'react'
import DataGrid from '../../../CRM/Component/Table'
import AjoutContact from '../../../CRM/Page/Ajout'
import Template from '../../Component/Message/Form'


const columns = [{
  header: 'Id',
  id: 'id',
  show: false,
}, {
  id: 'lien',
  header: null,
  sortable: false,
  width: 30,
  type: 'string',
  Cell: (row) => row.lien && <i className={'ei-module_gestion'}/>
}, {
  id: 'type_action_id',
  width: 30,
  header: 'Type',
  type: 'string',
  Cell: row => <Grid container justify={'center'} alignItems={'center'} alignContent={'center'} spacing={0}
                     style={{ margin: 0, padding: 0 }}>
    <i className={`ei-${row.type_action_id === Constants.typeAction.EmailRecu && 'commun_notification_email'
    || row.type_action_id === Constants.typeAction.EmailEnvoi && 'crm_campagne_email'
    || row.type_action_id === Constants.typeAction.SmsRecu && 'commun_notification_sms'
    || row.type_action_id === Constants.typeAction.SmsEnvoi && 'crm_campagne_sms'
      }`}/></Grid>
}, {
  id: 'source',
  width: 100,
  header: 'Source',
  type: 'string',
}, {
  id: 'contact_libelle',
  sortable: false,
  headerClassName: 'EurestoPrimary EurestoText--text',
  header: <strong style={{
    display: 'block',
    width: '100%'
  }}>{EurestoI18n.t('commun:Tiers')}</strong>,
  type: 'string'
}, {
  id: 'date_envoi',
  width: 100,
  header: EurestoI18n.t('commun:Date Envoi'),
  type: 'date',
  format: 'DD/MM/YY HH:mm'
}]

export default React.memo(props => {
  const [openModalContact, setOpenModalContact] = useState(false)
  const [phoneSelected, setPhoneSelected] = useState('')
  const [dossierSelected, setDossierSelected] = useState('')
  const [emailSelected, setEmailSelected] = useState('')
  const [addContact, setAddContact] = useState(-1)

  const associate = (row) => {
    if (row.type_action_id === Constants.typeAction.EmailRecu || row.type_action_id === Constants.typeAction.EmailEnvoi) {
      setEmailSelected(row.source)
    } else if (row.type_action_id === Constants.typeAction.SmsEnvoi || row.type_action_id === Constants.typeAction.SmsRecu) {
      setPhoneSelected(row.source)
    }
    setDossierSelected(row.dossier_id)
    setOpenModalContact(true)
  }

  const onCloseModal = () => {
    setPhoneSelected('')
    setEmailSelected('')
    setOpenModalContact(false)
    setAddContact(-1)
  }

  const onSelectedContact = async (contact) => {
    const r = await ApiRequest(project.api + 'crm', {
      requete: 'client',
      action: 'update',
      id: contact.id,
      coordonnees_keep_old: true,
      coordonnees: [{
        type: phoneSelected && 2 || 1,
        libelle: phoneSelected && 'Portable(SMS reçu)' || 'Email(Email reçu)',
        valeur: phoneSelected || emailSelected
      }]
    })
    if (r && r.code === 1 && dossierSelected) {
      await ApiRequest(project.api + 'sdd', {
        requete: 'dossier',
        action: 'update',
        id: dossierSelected,
        contact_id: contact.id
      })
    }
    onCloseModal()
  }

  const modalContact = <Modal open={openModalContact} onClose={onCloseModal} grid={{ xs: 10 }}>
    <EurestoDiv
      fromModal={true}
      buttonsLeft={addContact === -1 && [
        {
          title: 'Ajouter',
          icon: ' ei-commun_ajouter',
          cb: () => setAddContact(1)
        }
      ]} buttonsRight={[{
      icon: ' ei-commun_fermer',
      className: 'EurestoError--text EurestoText',
      cb: onCloseModal
    }
    ]} style={{
      margin: 0,
      padding: 0,
      maxHeight: User.CalculHeight.getHeightWanted(15),
      height: User.CalculHeight.getHeightWanted(15),
      overflowY: 'auto'
    }}>
      {addContact === -1 &&
      <DataGrid onClick={onSelectedContact} defaultSearch={{ '?actif': 1 }} type="client" view={'list'}
                name={Utils.getRandomNumber()}
                showSearch={true}/> ||
      <AjoutContact modalHeight={50} handleSaveContact={onSelectedContact}
                    handleCancelContact={onCloseModal}/>}
    </EurestoDiv>
  </Modal>

  return <React.Fragment>
    {modalContact}
    <Formulaire infinityScroll={true}
                isAllow={{}}
                handleAction={{
                  associate: associate
                }}
                btns={{
                  associate: {
                    title: 'Associer',
                    className: 'EurestoSecondary--text',
                    icon: 'ei-module_interface'
                  }
                }}
                formStyle={{ padding: 0 }}
                setAllow={(row) => ({
                  associate: !row.contact_id ||
                    (User.TypeAccess.get(Constants.access.EURESTO) && row.contact_id === 1)
                    || (!User.TypeAccess.get(Constants.access.EURESTO)  && row.contact_id === User.Entite.get().id)
                })}
                search={props.search || 'message_' + (props.name || '') + User.Entite.get().id}
                defaultObject={{
                  source: '+33',
                }} title={EurestoI18n.t('commun:Message')} form={<Template/>}
                module={Constants.module.MESSAGERIE}
                requete={Constants.donnee.message} columns={columns}/>
  </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/SDD/Page/Message/index.js